import { getRelatedPublicationListing } from 'component-library/templates/Publication/lib/get-related-publication-listing'
import { getUserTopicsPublicationListing } from 'component-library/templates/Publication/lib/get-user-topics-publication-listing'

import { isFeatureEnabled } from 'common/feature-togglings/features'
import { RelatedPublications } from './Publication.props'
import { DataDefinition } from 'json-react-layouts-data-loader'
import { ComponentServices } from 'common/routing/page-definition'

export interface PublicationDataContent {
    publicationId: string
}

export interface PublicationDataResult {
    relatedPublications?: RelatedPublications
    userTopicPublications?: RelatedPublications
}

export type ArticlePublicationDataDefinition = DataDefinition<
    PublicationDataContent,
    PublicationDataResult,
    ComponentServices
>

export const ArticlePublicationDataDefinitionLoader: ArticlePublicationDataDefinition = {
    loadData: async (props, services) => {
        let relatedPublications: RelatedPublications | undefined
        let userTopicPublications: RelatedPublications | undefined

        const appState = services.store.getState()
        if (isFeatureEnabled(appState.toggles, 'related-content')) {
            relatedPublications = await getRelatedPublicationListing(services, props.publicationId)
        }

        if (
            isFeatureEnabled(appState.toggles, 'my-home') &&
            appState.personalisation.myCollections.length > 0
        ) {
            userTopicPublications = await getUserTopicsPublicationListing(
                services,
                appState.personalisation.myCollections.map(collection => collection.topic)
            )
        }

        return {
            relatedPublications,
            userTopicPublications,
        }
    },
}
